<template>
  <v-form v-model="isFormValid" ref="form">
    <div>
      <dashboard-header :text="item ? $t('ui.updateDepartment'): $t('ui.createDepartment')" :on-back="onGoBack"/>
      <div class="d-flex justify-center align-center">
        <v-card elevation="0"
                class="card-border-10 w-75">
          <v-card class="m-4"
                  outlined>
            <div class="d-flex custom-card-head p-4">
              <div class="d-inline text-sm-h5 ">{{ $t("ui.captionDepartment") }}</div>
            </div>
            <v-divider class="m-0"></v-divider>
            <div class="px-6 pt-6">
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('ui.nameDepartment') }}</p>
              </div>
              <v-textarea
                  v-model="department.name"
                  :placeholder="placeholderName"
                  :rules="ruleDepartmentName"
                  counter="255"
                  rows="1"
                  auto-grow
                  outlined
              >
              </v-textarea>
            </div>
            <div class="px-6">
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('ui.accountName') }}</p>
              </div>
              <v-text-field
                  v-model="department.dpInchargeEmployeeName"
                  counter="20"
                  rows="1"
                  auto-grow
                  outlined
                  :placeholder="placeholderAccount"
                  :rules="ruleAccountName"
              >
              </v-text-field>
            </div>
            <div class="px-6">
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('ui.email') }}</p>
              </div>
              <v-textarea
                  v-model="department.dpEmail"
                  rows="1"
                  auto-grow
                  outlined
                  :placeholder="placeholderEmail"
                  :rules="ruleAccountEmail"
              >
              </v-textarea>
            </div>
            <div class="px-6">
              <div class="d-flex">
                <p class="ms-1 text-sm-h5">{{ $t('ui.phoneNumber') }}</p>
              </div>
              <div class="d-flex">
                <v-responsive max-width="80">
                   <v-text-field readonly rows="1" outlined style="margin-right: 10px" prefix="+84"></v-text-field>
                 </v-responsive>
                <v-text-field
                    v-model="department.dpPhoneNumber"
                    outlined
                    :placeholder="placeholderPhoneNumber"
                    counter="20"
                    auto-grow
                >
                </v-text-field>
              </div>
            </div>
            <div class="d-flex align-center">
              <v-col class="py-0">
                <div class="d-flex align-center ml-4">
                  <v-switch
                      inset
                      v-model="department.inCharge"
                      @change="onSwitchInCharge"
                      :disabled="interHospitalDepartment"
                  ></v-switch>
                  <div class="text-sm-h5">{{ $t('ui.inCharge') }}</div>
                </div>
              </v-col>
            </div>
          </v-card>
          <div class=" m-4">
            <v-btn
                elevation="0"
                class="no-uppercase btn-custom-primary"
                :disabled="!isFormValid"
                @click="onSave"
            >{{ $t('ui.save') }}
            </v-btn>
          </div>

        </v-card>
      </div>
    </div>
  </v-form>

</template>

<script>
import DashboardHeader from "../component/DashboardHeader";
import {API2} from "../../api";
import mixin from "../../mixin";
import i18n from "../../lang/i18n";

export default {
  name: "CreateAndUpdate",
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      interHospitalDepartment: 0,
      department: this.getDefaultDepartment(),
      isFormValid: false
    }
  },
  mounted() {
    this.onTab(this.item)
  },
  computed: {
    isVisible() {
      return !this.item
    },
    isInterHospitalDepartment() {
      // Disable toggle OFF for inter-hospital departments (when editing and inCharge is 1)
      return this.item && this.department.inCharge === 1
    },
    ruleDepartmentName() {
      let departmentName = this.department.name
      return [
        departmentName.length > 0
        && departmentName.length <= 255
        && departmentName.trim().length > 0
        || this.$t("ui.MSG0046")
      ]
    },
    ruleAccountName() {
      let accountName = this.department.dpInchargeEmployeeName
      return [
        // !!accountName && accountName.length > 0 || this.$t("ui.MSG0104"),
        !accountName && accountName.length > 0 || /^(?=.{8,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/.test(accountName) || this.$t("ui.MSG0102")
      ]
    },
    ruleAccountEmail() {
      let email = this.department.dpEmail
      const localPartLength = email ? email.split('@')[0].length : 0
      return [
        // Allow empty. If provided, limit username (local-part) to max 64 characters.
        !email || localPartLength <= 64 || this.$t("ui.MSG0036"),
        // Allow empty. If provided, must be a valid email format.
        !email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || this.$t("ui.MSG0048")
      ]
    },
    ruleAccountPhone() {
      let phone = this.department.dpPhoneNumber
      return [
        !phone || phone.length <= 20 || this.$t("ui.MSG0103"),
        !phone || phone.trim().length > 0 || this.$t("ui.MSG0103"),
        !phone || /^[0-9]+$/.test(phone) || this.$t("ui.MSG0103")
      ]
    },
    placeholderName() {
      return this.$t('ui.enterNameDepartment')
    },
    placeholderAccount() {
      return this.$t('ui.username')
    },
    placeholderEmail() {
      return this.$t('account.enterEmail')
    },
    placeholderPhoneNumber() {
      return this.$t('employee.enterPhoneNumber')
    },
  },
  methods: {
    onGoBack() {
      this.openTab(0)
    },
    onTab(item) {
      this.$refs.form.resetValidation()
      this.department = this.getDefaultDepartment()
      if (item) this.getData(item)
    },
    getDefaultDepartment() {
      return {
        name: '',
        dpInchargeEmployeeName: '',
        dpEmail: '',
        dpPhoneNumber: '',
        inCharge: 0,
      }
    },
    async getData(item) {
      let res = await this.get(API2.DEPARTMENT, {path: item.data.departmentId})
      if (res) {
        this.department = res
        this.interHospitalDepartment = res?.inCharge;
        // console.log('this.department', this.department)
      } else {
        // No data found, go back to list
        this.onGoBack();
      }
    },
    async onSave() {
      let data = {
        name: this.department.name,
        dpInchargeEmployeeName: this.department.dpInchargeEmployeeName,
        dpEmail: this.department.dpEmail,
        dpPhoneNumber: this.department.dpPhoneNumber,
        inCharge: this.department.inCharge ? "1" : "0",
        fastCreate: "0"
      }
      if (this.item) {
        data.path = this.department.departmentId
        data.fastCreate = "0"
      }
      let res = this.item ? await this.put(API2.DEPARTMENT, data) : await this.post(API2.DEPARTMENT, data)
      if (!res) return
      this.showToast("success", i18n.t("ui.toastSuccess"), '')
      this.openTab(0, this.item)
    },
    onSwitchInCharge(newValue) {
      // Prevent turning OFF for inter-hospital departments
      if (this.isInterHospitalDepartment && !newValue) {
        // Reset to ON state
        this.$nextTick(() => {
          this.department.inCharge = 1
        })
        return
      }
      this.department.inCharge = newValue ? 1 : 0
    }
  },
}
</script>

<style scoped>

.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

</style>